// import { getStore } from '@remote/pan/plugins/vuex-store-plugin'

/**
 * 获取用户信息
 * @author zhaobing
 * @param {array} infos - 需要的用户信息
 * @return {Promise}
 * 支持以下参数
 *  userId
 sessionId
 userNick
 userName
 peerid 如果在客户端，获取的是客户端peerid，web端为账号构造的
 thunder 迅雷版本号
 thunderComponent 迅雷浏览器组件版本号
 */
export default function getUserInfo (infos = ['peerid', 'userid', 'version', 'sessionid', 'isNative']) {
  // const storeUserInfo = getStore().state.users.curUser
  // const userInfo = Object.assign({}, storeUserInfo, {
  //   version: storeUserInfo.thunder || '',
  //   userid: storeUserInfo.userId || '0',
  //   sessionid: storeUserInfo.sessionId || '',
  //   peerid: storeUserInfo.peerId || 'AAAAAAAAAAAAAAAA',
  //   isNative: getStore().state.isNative,
  // })

  // return Promise.resolve(infos.map(key => userInfo[key]))
}
export function pubcCR5an44wPLuOhephXdZ2mCuDTv2dGo8 (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./error-message.js').publ0fJmPAzCl7DbIKbk1A3q3p33l8Z7MY8
            const nextPart2 = require('./get-user-info.js').pubAx4iJXvCBK1trcGVH3ZNjFBj4Zzok7dQ
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubsC46w9Fd1eyHNQoBLuXIu7wZ3o1HAdys (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./captcha.js').pubY0EHxdFD5j6lE7ISQr4cfvzs2rtlJRkp
            const nextPart2 = require('./qrImg.js').pubkaCpTrRJyp7S5vKjWlHptf4GPDNmMFbY
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubrvwlHEDo8EvWPZ9hkDk8OnjFJUf5xRxs (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'u3hqHKOfTVtJcAU0', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./qrImg.js').pubeJcexuSTh0cydsZlbBOLOaGHE2Ydoh4x
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubOSYEuro86NP9gU9O5m71iYPqqMAFEiV3 (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./sso.js').pubZgx6VxiaM23d2epMCWwWrpc7x4vwkeya
            const nextPart2 = require('./sso.js').pubiTifDhIAj9glgs40QxfLtJ92NIvESiIg
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubqhEEF96c5iRMmoLYu5ptjxqycE4IjYSR (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'md5', salt: 'VHypPRgbhl', end: 'undefined' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./sso.js').pubbcOi40TICOq8wXbmyJwkDLWk5kFSXfKg
              return nextPart1(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }